export default __webpack_public_path__ + "static/media/B52_11.56af2d7c.webp";